export const USER_TODO = 'USER_TODO';

// visiting card

export const UPDATE_CARD_DETAILS = 'UPDATE_CARD_DETAILS';

export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';

export const UPDATE_PROFILE = 'UPDATE_PROFILE';

export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE';

// session

export const SESSION_DETAILS = 'SESSION_DETAILS';
export const SESSION_SETTINGS = 'SESSION_SETTINGS';

// audio , video, speaker setting
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';

// message count
export const ADD_PRIVATE_COUNT = 'add_private_count';
export const INCREMENT_COMMON_COUNT = 'increment_common_count';
export const RESET_PRIVATE_COUNT = 'reset_private_count';
export const RESET_COMMON_COUNT = 'reset_common_count';


// recording

export const RECORDING_STATUS = 'RECORDING_STATUS'

// * GLM *
export const SET_GROUP_LEADER = 'SET_GROUP_LEADER'
export const SET_MY_GROUP = 'SET_MY_GROUP'
export const SET_ALL_GROUP = 'SET_ALL_GROUP'


// ss

export const SHARE_SCREEN = 'SHARE_SCREEN'
export const SESSION_MODE = 'SESSION_MODE'
export const WHITEBOARD_DETAILS = 'WHITEBOARD_DETAILS'

// private video chat
export const PRIVATE_VIDEO_CHAT_DATA = 'PRIVATE_VIDEO_CHAT_DATA'
